import NextLink from 'next/link';
import {
  Alert,
  Button,
  VStack,
  Stack,
  useColorModeValue,
} from '@chakra-ui/react';
import { sendAnalyticsEvent } from '../common/libs/googleAnalytics';

const NeedLogin = ({
  gaLabelKey,
  redirectUrl,
}: {
  gaLabelKey: string;
  redirectUrl: string;
}) => {
  const loginUrl = `/login?redirectUrl=${redirectUrl}`;
  const signupUrl = `/account/signup?redirectUrl=${redirectUrl}`;
  const loginButtonColor = useColorModeValue('white', 'blackAlpha.600');

  return (
    <VStack>
      <Alert
        status="info"
        justifyContent="center"
        borderRadius="md"
        pt={10}
        pb={10}
        mb={4}
      >
        このページを閲覧するにはログインが必要です。
      </Alert>
      <Stack direction={['column', 'row']} spacing="20px" maxWidth="100%">
        <NextLink href={loginUrl} passHref>
          <Button
            as="a"
            colorScheme="brand"
            size="lg"
            width="400px"
            maxWidth="100%"
            onClick={() =>
              sendAnalyticsEvent(
                'induction',
                'login',
                `need_login_${gaLabelKey}`,
              )
            }
          >
            ログイン
          </Button>
        </NextLink>
        <NextLink href={signupUrl} passHref>
          <Button
            as="a"
            bgColor={loginButtonColor}
            color="brand.400"
            borderColor="brand.400"
            borderWidth={1}
            size="lg"
            width="400px"
            maxWidth="100%"
            onClick={() =>
              sendAnalyticsEvent(
                'induction',
                'signup',
                `need_login_${gaLabelKey}`,
              )
            }
          >
            アカウントをお持ちでない方はこちら
          </Button>
        </NextLink>
      </Stack>
    </VStack>
  );
};

export default NeedLogin;
